import MaterialReceive from './MaterialReceive';
import PanelMrDetail from './PanelMrDetail';
import PanelEvaluation from './PanelEvaluation';
import PanelFine from './PanelFine';
import PanelGRInvoiceDetail from './PanelGRInvoiceDetail'

export default MaterialReceive;
export {
    PanelMrDetail,
    PanelEvaluation,
    PanelFine,
    PanelGRInvoiceDetail
}